<template lang="pug">
  .root
    Base(:liveType="liveType")

</template>

<style src="./Paid.scss" lang="scss" scoped>

</style>

<script>
import Base from './components/Base'
import {LIVE_TYPE} from './helper/def'

export default {
  name: "TopLivePaid",
  components: {
    Base
  },
  data() {
    return {
      liveType: LIVE_TYPE.PAID
    }
  },
  props: {},
  computed: {},
  watch: {},
  mounted() {},
  async created() {},
  updated() {},
  async destroyed() {},
  methods: {}
};
</script>
